import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function MasonryShowcaseFeaturedServices({ setIsdata }) {
  const [featuredService, setFeaturedService] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getFeaturedService();
  }, []);

  const getFeaturedService = async () => {
    setLoading(true);
    const response = await SendPostRequest("services/featured_services");
    if (response?.data.length < 5 && sitedata?.site_type === "hospitals") {
      setIsdata(true);
    }
    setFeaturedService(response?.data);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        featuredService?.length > 0 && (
          <div
            id="portfolio-section"
            className="portfolio-section py-5 my-4 section-bg-img"
            style={{ backgroundImage: `url(/assets/images/mist/specialities-masonry-showcase-bg.webp)` }}
          >
            <div className="row">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="title mb-0 text-uppercase typo-white">
                      {sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div
                  className="row portfolio-wrap portfolio-classic-pro px-4"
                  data-animation="fadeInDown"
                >
                  {featuredService?.slice(0, 6)?.map((service, index) => (
                    <div
                      className="portfolio-item portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 col-xs-6 filter web
                        animated fadeInDown visible
                        "
                      key={index}
                    >
                      <div className="portfolio-thumb relative">
                        <Link
                          to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                        >
                          <img
                            src={service?.service_image_url}
                            className="img-fluid"
                            alt={service?.title}
                            title={service?.service_title}
                            style={{ height: "auto" }}
                          />
                        </Link>
                        <div className="portfolio-wrap mansory-services-mobile-view">
                          <div className="portfolio-details-overlay typo-white">
                            <h3 className="mb-2">
                              <Link
                                to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                  .replaceAll(" ", "-")
                                  .replaceAll("/", "-")}`}
                              >
                                {service?.service_title}
                              </Link>
                            </h3>
                            <div
                              className="portfolio-content w-75"
                              dangerouslySetInnerHTML={{
                                __html:
                                  limitParagraphByCharLimit(service?.clean_service_description, 80) +
                                  (service?.clean_service_description?.length > 80 ? "..." : ""),
                              }}

                            />
                          </div>
                          <div className="portfolio-icons">
                            <Link
                              to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                .replaceAll(" ", "-")
                                .replaceAll("/", "-")}`}
                              className="link-icon"
                            >
                              <i className="icon-link"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
}

export default MasonryShowcaseFeaturedServices;